export default __webpack_public_path__ + "static/media/small-clip.5c2a1c50.svg";